import BetHistory from './BetHistory';

export default BetHistory;